import axios from 'axios'
import { useMainStore } from '@/stores'

// Check token to add Authorization header and change isLoading value
axios.interceptors.request.use((request) => {
  const token = localStorage.getItem('token')
  const isAuthUrl = request.url.includes('release') || request.url.includes('sync')
  useMainStore().setLoading(true)

  if (token && isAuthUrl) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  return request
})

// Change isLoading value with success or error response
axios.interceptors.response.use(
  response => {
    useMainStore().setLoading(false)
    return response
  }, error => {
    useMainStore().setLoading(false)
    return Promise.reject(error)
  })
